document.addEventListener('DOMContentLoaded', function () {
  applyStoredPreference()
  waitForRejectButton()
})

function waitForRejectButton() {
  const checkInterval = setInterval(() => {
    const rejectAllButton = document.querySelector(
      'button.cm__btn[data-role="necessary"]'
    )
    if (rejectAllButton) {
      clearInterval(checkInterval)
      rejectAllButton.addEventListener('click', function () {
        document.cookie = 'user_consent=reject; path=/; max-age=31536000'
        disableTracking()
      })
    }
  }, 300)
}

function applyStoredPreference() {
  if (getCookie('user_consent') === 'reject') {
    disableTracking()
  }
}

function disableTracking() {
  if (getCookie('reload_once')) {
    document.cookie =
      'reload_once=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
    return
  }

  const trackingCookies = [
    '_ga',
    '_gid',
    '_gat',
    '_gcl_au',
    '_ga_XH6YLEDQ2W',
    'GS1.1',
  ]

  trackingCookies.forEach((cookieName) => {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
    const domainParts = window.location.hostname.split('.')
    while (domainParts.length > 1) {
      const domain = domainParts.join('.')
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${domain};`
      domainParts.shift()
    }
  })

  if (window.dataLayer) {
    window.dataLayer = []
  }

  if (window.gtag) {
    window.gtag = function () {}
  }

  const gaScript = document.querySelector(
    'script[src*="googletagmanager.com/gtag/js"]'
  )
  if (gaScript) gaScript.remove()

  const gtmScript = document.querySelector(
    'script[src*="googletagmanager.com/gtm.js"]'
  )
  if (gtmScript) gtmScript.remove()

  const gtmIframe = document.querySelector(
    'iframe[src*="googletagmanager.com"]'
  )
  if (gtmIframe) gtmIframe.remove()

  document.cookie = 'reload_once=true; path=/; max-age=60'
  location.reload()
}

function getCookie(name) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
  return null
}
